import React, {ChangeEvent, useContext, useEffect, useState} from 'react';
import {Button, Col, Form} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {login} from "../../redux/adminuser"
import {loginAuth, MenuAuthority} from "../../redux/authority"
import axios from "axios";
import Url from './Url'
import {AesEncrypt} from "./UtilComponent";
import {RootState} from "../../redux/store";

function Login() {
    const url = useContext(Url)
    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-LOGIN'
    })
    useEffect(() => {
        axios.get(url + "checktoken", {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        }).then(res => {
            if (res.data === true) {
                navigate('/UserManagement')
            } else if (res.data === false) {
                console.log('checktoken 실패')
            }
        })
    }, [])

    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [id, setId] = useState("")
    const [password, setPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("")

    const handleLogin = async (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (id === ""){
            setErrorMessage('아이디를 입력해 주세요')
        }else if (password === ""){
            setErrorMessage('비밀번호를 입력해 주세요')
        }else {
            try {
                await axios.post(url + 'login', {
                    userId: id,
                    password: AesEncrypt(password)
                }).then(response => {
                    const res = response.data.result
                    localStorage.setItem('Authorization', response.headers.authorization)
                    localStorage.setItem('Refresh', response.headers.refresh)
                    dispatch(login({id: id, customerCode: res.customerCode}))
                    const convertArrayToObject = <T extends {[key: string]: any}>(array: T[], keyField: keyof T): Record<string, T> =>
                        array.reduce((obj: Record<string, T>, item: T) => {
                            obj[item[keyField] as string] = item;
                            return obj;
                        }, {});

                    const menuAuthObject = convertArrayToObject(res.menuAuth as MenuAuthority[], 'menuCode');
                    dispatch(
                        loginAuth({
                            authorityId:res.authorityId, firstUrl: res.firstUrl, MENUAUTH:menuAuthObject
                            })
                    )
                    navigate(res.firstUrl)
                })
            } catch (e: any) {
                const error = e.response.data;
                console.log(e)
                if (error.code === 400) {
                    setErrorMessage(`${error.message}`);
                } else if (error.code === 423) {
                    setErrorMessage(`${error.message}`)
                }
            }
        }
    }

    return (
        <div className="body">
            <div className="container">
                {/*Outer Row*/}
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                {/*Nested Row within Card Body*/}
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="p-5">
                                            <div className="text-center">
                                                <h1 className="h4 text-gray-900 mb-4">로그인</h1>
                                            </div>
                                            <Form className="login_form" onSubmit={handleLogin}>
                                                <Col>
                                                    <Form.Control id="form-control-id" placeholder="아이디" value={id}
                                                                  onChange={(e) => setId(e.target.value)}/>
                                                </Col>
                                                <Col>
                                                    <Form.Control id="form-control-pass" type="password"
                                                                  placeholder="비밀번호" value={password}
                                                                  onChange={(e) => setPassword(e.target.value)}/>
                                                </Col>
                                                <div className="d-grid gap-2">
                                                    <Button type="submit" id="log_in_button" size="lg">
                                                        로그인
                                                    </Button>
                                                </div>
                                            </Form>
                                            <hr/>
                                            <span>{errorMessage}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{justifyContent:"center", display:"flex"}}>
                            <span style={{color:"white"}}>Copyright &copy; Telecons 2023</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;